import { useCallback } from 'react';
import { getDateFromDateOrNow } from './shared';
export const useKeyboardAccesibility = ({ currentValue, minDate, maxDate, handleChange, }) => {
    const onKeyDown = useCallback((event) => {
        const focusedDate = currentValue || new Date();
        let newDate = new Date(focusedDate);
        const keyAdjustments = {
            ArrowUp: () => newDate.setDate(focusedDate.getDate() - 7),
            ArrowDown: () => newDate.setDate(focusedDate.getDate() + 7),
            ArrowLeft: () => newDate.setDate(focusedDate.getDate() - 1),
            ArrowRight: () => newDate.setDate(focusedDate.getDate() + 1),
            PageUp: () => {
                if (event.ctrlKey || event.metaKey) {
                    newDate.setFullYear(focusedDate.getFullYear() - 1);
                }
                else {
                    newDate.setMonth(focusedDate.getMonth() - 1);
                }
            },
            PageDown: () => {
                if (event.ctrlKey || event.metaKey) {
                    newDate.setFullYear(focusedDate.getFullYear() + 1);
                }
                else {
                    newDate.setMonth(focusedDate.getMonth() + 1);
                }
            },
            t: () => (newDate = new Date()),
            T: () => (newDate = new Date()),
        };
        if (!keyAdjustments[event.key]) {
            return;
        }
        keyAdjustments[event.key]();
        if (minDate && newDate < minDate) {
            newDate = new Date(getDateFromDateOrNow(minDate).setHours(0, 0, 0, 0));
        }
        if (maxDate && newDate > maxDate) {
            newDate = new Date(getDateFromDateOrNow(maxDate).setHours(0, 0, 0, 0));
        }
        handleChange && handleChange(newDate);
    }, [currentValue, handleChange, minDate, maxDate]);
    return {
        onKeyDown,
    };
};
